export const newId = (): string => {
    return crypto.randomUUID();
};
